export default __webpack_public_path__ + "static/media/TermsAndConditions.79e3bafe.md";